import { Link } from "react-router-dom";

const MENTION = /@\[([^\]]+)\]\(([^)]+)\)/g;

export const RichText = ({ text }) => {
  if (!text) return null;
  const out = [];
  let last = 0;
  for (const m of text.matchAll(MENTION)) {
    out.push(text.slice(last, m.index));
    out.push(<Link key={m.index} to={`/profile/${m[2]}`} className="font-semibold text-tm-green-light hover:underline">@{m[1]}</Link>);
    last = m.index + m[0].length;
  }
  out.push(text.slice(last));
  return <>{out}</>;
};
